import { useSession } from '../Context';

const Default = ({ fallback, setState }) => {
  const { state } = useSession();
  return (
    <div className='flex items-center justify-center bg-gray-200'>
      <div className='border border-black bg-gray-100 p-5 shadow-xl'>
        {state.current()}
      </div>
    </div>
  );
};
export default Default;
